// removed by extract-text-webpack-plugin
module.exports = {"iframeWrapper":"iframe-wrapper--3aaI3","iframeContainer":"iframe-container--9QX7o"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/iframeWrapper/iframeWrapper.scss
// module id = spwn
// module chunks = 1